import { useLocation, useMatch } from 'react-router-dom';
import {
  ACTIVATE_CLIENT_ROUTE,
  PHONE_SUPPRESSED_CLIENTS,
  SIGN_IN_ROUTE_PATHS,
  SIGN_IN_ROUTE_PREFIX,
} from './config';

type HeaderRouteFlags = {
  isSignInRoute: boolean;
  isPhoneSuppressedClient: boolean;
};

/**
 * `useMatch`, not `useParams`: the header renders from `Layout`, above the route that
 * declares `:client`, so `useParams()` would never see it.
 */
function useHeaderRouteFlags(): HeaderRouteFlags {
  const { pathname } = useLocation();
  const activateClientMatch = useMatch(ACTIVATE_CLIENT_ROUTE);

  const isSignInRoute =
    pathname.startsWith(SIGN_IN_ROUTE_PREFIX) ||
    SIGN_IN_ROUTE_PATHS.includes(pathname);

  const client = activateClientMatch?.params.client?.toLowerCase() ?? '';
  const isPhoneSuppressedClient = PHONE_SUPPRESSED_CLIENTS.includes(client);

  return { isSignInRoute, isPhoneSuppressedClient };
}

export default useHeaderRouteFlags;
